import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from '../../Parts/Button';
import Typography from 'material-ui/Typography';

const styles = () => ({
  root: {
    width: '100%',
    background: '#FFFFFF',
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    padding: '18px 20px',
    margin: '10px 0px',
    textAlign: 'left',
  },

  text: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  }
});

class CorporationSuggestion extends React.Component {
  handleLinkCorporation = () => {
    this.props.handleLinkCorporation(this.props.corporation, !this.props.isLinked)
  }

  render() {
    const { classes, corporation, isSavingCorp: _isSavingCorp, handleLinkCorporation: _handleLinkCorporation, disabled, isLinked, ...rest } = this.props;

    return (
      <div className={classes.root} {...rest}>
        <div className={classes.text}>
          <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
            {`${corporation.name} (法人番号: ${corporation.corporate_number})`}
          </Typography>
          <Typography variant="body1">
            {corporation.prefecture_name + corporation.city_name + corporation.street_number}
          </Typography>
        </div>
        <Button
          type={isLinked ? "line" : "ghost"}
          text={isLinked ? "選択解除" : "この法人番号を選択"}
          disabled={disabled}
          handleClickButton={this.handleLinkCorporation}
          style={{ width: '177px', boxSizing: 'border-box' }}
        />
      </div>
    )
  }
}

CorporationSuggestion.propTypes = {
  classes: PropTypes.object.isRequired,
  corporation: PropTypes.object.isRequired,
  isLinked: PropTypes.bool,
  disabled: PropTypes.bool,
  isSavingCorp: PropTypes.bool,
  handleLinkCorporation: PropTypes.func.isRequired,
};

CorporationSuggestion.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(CorporationSuggestion);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/CorporationSuggestion.jsx